// extracted by mini-css-extract-plugin
export default {"link":"_F-z","disabled":"aG-z"};